/**
 * @file LoginForm.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Component manages the inputs and button / like form in login page.
 */
import {
  Alert,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { emailRegex } from "../../../components/constants/regex";

export const LoginForm = ({ onSubmit }) => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm();

  return (
    <Box
      component="form"
      maxWidth={400}
      width="100%"
      onSubmit={handleSubmit((data) => onSubmit(data, setError))}
    >
      <Stack spacing={3}>
        <TextField
          name="email"
          label="Email"
          sx={{ bgcolor: "white" }}
          fullWidth
          {...register("email", {
            required: "Email is required",
            pattern: {
              value: emailRegex,
              message: "Invalid email address",
            },
          })}
          error={!!errors.email}
          helperText={errors.email ? errors.email.message : ""}
        />
        <TextField
          name="password"
          label="Password"
          type="password"
          fullWidth
          {...register("password", {
            required: "Password is required",
          })}
          error={!!errors.password}
          helperText={errors.password ? errors.password.message : ""}
        />
        <Stack
          alignSelf="flex-end"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography color="error" fontSize={14} fontWeight={500}>
            <Link to="/candidate-forgotpassword">Forgot password?</Link>
          </Typography>
        </Stack>

        {errors.root && <Alert severity="error">{errors.root.message}</Alert>}

        <Button
          type="submit"
          size="large"
          variant="contained"
          disabled={isSubmitting}
          color="success"
        >
          Sign In
        </Button>
      </Stack>
    </Box>
  );
};
